<template>
  <v-dialog scrollable v-model="model" persistent max-width="1200px">
    <v-card>
      <v-card-text v-html="html" />

      <v-card-actions>
        <v-btn color="primary" @click="printHtml()">
          <v-icon>print</v-icon>
          {{ $t("globals.print") }}
        </v-btn>
        <v-btn text @click="$emit('close')">
          {{ $t("globals.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["model", "html"],
  data() {
    return {
      printWindow: null
    };
  },
  methods: {
    printHtml() {
      this.printWindow = window.open("", "PRINT", "height=600,width=600");

      this.printWindow.document.write(
       this.html
      );
      this.printWindow.document.close(); // necessary for IE >= 10
      this.printWindow.focus(); // necessary for IE >= 10*/

      this.printWindow.print();
      // this.printWindow.close();
// console.log("hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh")
      return false;
    },
  },
};
</script>
